// extracted by mini-css-extract-plugin
export var animationAbsolute = "_13-q";
export var animationRelative = "_13-p";
export var backdropBlur = "_13-0";
export var detailLabelCell = "_13-12";
export var detailTable = "_13-11";
export var detailValueCell = "_13-13";
export var docIconBox = "_13-1d";
export var docIconBoxMd = "_13-1f";
export var docIconBoxSm = "_13-1e";
export var docTypeRow = "_13-16";
export var docTypeRowInner = "_13-17";
export var dropdownMatchDatePicker = "_13-3";
export var evidenceCardContent = "_13-1c";
export var fileUploadSpin = "_13-j";
export var gorgiasOpenButton = "_13-15 _13-d";
export var gorgiasTicketCard = "_13-14";
export var heroModalFooterButton = "_13-18";
export var hiddenContainer = "_13-o";
export var iconPrimary = "_13-1g";
export var iconQuaternary = "_13-1i";
export var iconTertiary = "_13-1h";
export var integrationCard = "_13-1";
export var integrationLogoBox = "_13-2";
export var mainColumnSticky = "_13-1b";
export var maxWidthContainer = "_13-19";
export var modalContentBody = "_13-a";
export var modalHeaderImage = "_13-5";
export var modalImageLabel = "_13-7";
export var modalImageOverlay = "_13-6";
export var modalImageSubtitle = "_13-9";
export var modalImageTitle = "_13-8";
export var modalImageWrapper = "_13-4";
export var modalStickyFooter = "_13-b";
export var removeButton = "_13-e";
export var sidebarColumn = "_13-1a";
export var spinner = "_13-i";
export var timelineLine = "_13-y";
export var timelineLineBlack = "_13-10 _13-y";
export var timelineLineGray = "_13-z _13-y";
export var timelineLineHeight = "_13-x";
export var tlDotActivate = "_13-u";
export var tlDotActivateAnim = "_13-t";
export var tlDotHide = "_13-s";
export var tlDotHideAnim = "_13-r";
export var tlLineActivate = "_13-w";
export var tlLineActivateAnim = "_13-v";
export var uploadHint = "_13-n";
export var uploadIconBox = "_13-k";
export var uploadLabel = "_13-m";
export var uploadText = "_13-l";
export var uploadZone = "_13-f";
export var uploadZoneCursorDefault = "_13-h";
export var uploadZoneCursorPointer = "_13-g";
export var uploadedFileRow = "_13-c";
export var viewButton = "_13-d";